import React from 'react';
import { Facebook, Instagram, Twitter, Mail, Phone } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Footer() {
  const navLinks = [{
    name: 'Home',
    href: '/'
  }, {
    name: 'Our Services',
    href: '/services'
  }, {
    name: 'About Us',
    href: '/#about'
  }, {
    name: 'Contact Us',
    href: '/#contact'
  }, {
    name: 'FAQ',
    href: '/#faq'
  }];
  const services = ['Commercial Cleaning', 'Basic Home Cleaning', 'Spring / Deep Cleaning', 'Move-in / Move-out', 'Post Renovation', 'Airbnb / Short Term Rental'];
  return <footer className="bg-primary text-white pt-24 md:pt-32 pb-12 relative z-30 border-t border-white/10" data-id="element-65">
      <div className="container mx-auto px-6 md:px-12" data-id="element-66">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 mb-20" data-id="element-67">
          {/* Brand & Nav */}
          <div data-id="element-68">
            <h3 className="text-sm font-bold text-white/50 uppercase tracking-widest mb-6" data-id="element-69">
              Site Map
            </h3>
            <div className="flex flex-wrap items-baseline" data-id="element-70">
              {navLinks.map((link, index) => <span key={link.name} className="flex items-baseline" data-id="element-71">
                  <Link to={link.href} className="text-3xl md:text-5xl font-heading font-bold uppercase tracking-tight text-white/80 hover:text-accent transition-colors" data-id="element-72">
                    {link.name}
                  </Link>
                  {index < navLinks.length - 1 && <span className="text-3xl md:text-5xl font-heading font-bold text-white/40 mx-1" data-id="element-73">
                      /
                    </span>}
                </span>)}
            </div>
          </div>

          {/* Services */}
          <div className="flex flex-col lg:items-end" data-id="element-74">
            <h3 className="text-sm font-bold text-white/50 uppercase tracking-widest mb-6" data-id="element-75">
              Services
            </h3>
            <ul className="space-y-3 text-left lg:text-right" data-id="element-76">
              {services.map(service => <li key={service} data-id="element-77">
                  <Link to="/services" className="text-lg md:text-xl font-heading font-medium uppercase tracking-wide text-white/80 hover:text-accent transition-colors" data-id="element-78">
                    {service}
                  </Link>
                </li>)}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-8 pt-12 border-t border-white/10" data-id="element-79">
          {/* Logo */}
          <div className="flex items-center gap-4" data-id="element-80">
            <img src="https://cdn.magicpatterns.com/uploads/jc63Wcs2z1JuqZfJSF71Nx/logo-white.png" alt="Smith & Jengs" className="h-12" data-id="element-81" />
          </div>

          {/* Contact Info */}
          <div className="flex flex-col md:flex-row items-center gap-6 md:gap-12 text-sm text-white/60" data-id="element-82">
            <a href="mailto:smithsandjengs@yahoo.com" className="hover:text-white transition-colors flex items-center gap-2" data-id="element-83">
              <Mail size={16} data-id="element-84" /> smithsandjengs@yahoo.com
            </a>
            <a href="tel:+4407432285564" className="hover:text-white transition-colors flex items-center gap-2" data-id="element-85">
              <Phone size={16} data-id="element-86" /> 07432285564
            </a>
          </div>

          {/* Socials */}
          <div className="flex items-center gap-4" data-id="element-87">
            <a href="#" className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center text-white hover:bg-white hover:text-primary transition-colors" data-id="element-88">
              <Facebook size={18} data-id="element-89" />
            </a>
            <a href="#" className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center text-white hover:bg-white hover:text-primary transition-colors" data-id="element-90">
              <Instagram size={18} data-id="element-91" />
            </a>
            <a href="#" className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center text-white hover:bg-white hover:text-primary transition-colors" data-id="element-92">
              <Twitter size={18} data-id="element-93" />
            </a>
          </div>
        </div>
      </div>
    </footer>;
}